import { RPNService } from './rpn.service';

export default angular
  .module('sfMobile.services.rpn', ['sfMobile.services.localization'])
  .service('rpnService', RPNService).name;
